import { TypeInitProps, TypeRequest } from '../../../types';
import { encryptParams } from '../../../utils/index';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class SuperAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @return {Promise} send result
   */
  sendCodeToOldManager = (params: { extra_params?: object } = {}) => {
    const { extra_params = {} } = params;
    const data = encryptParams({ type: 22, ...extra_params }, ['type']);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @return {Promise} send result
   */
  sendEmailCodeToOldManager = (params: { extra_params?: object } = {}) => {
    const { extra_params = {} } = params;
    const data = encryptParams({ type: 6, ...extra_params }, ['type']);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  verifyOldManagerMobile = (params: {
    code: string;
    extra_params?: object;
  }) => {
    const { code, extra_params = {} } = params;
    const data = encryptParams({ code, type: 22, ...extra_params }, [
      'code',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.VERIFY_MOBILE_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  verifyOldManagerEmail = (params: { code: string; extra_params?: object }) => {
    const { code, extra_params = {} } = params;
    const data = encryptParams({ code, type: 6, ...extra_params }, [
      'code',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.VERIFY_EMAIL_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} mobile - mobile number
   * @param {string} verify_ticket - the ticket returned by verification
   * @return {Promise} send result
   */
  sendCodeToNewManager = (params: {
    mobile: string;
    verify_ticket: string;
    extra_params?: object;
  }) => {
    const { mobile, verify_ticket, extra_params = {} } = params;
    const data = encryptParams(
      { mobile, verify_ticket, type: 101, ...extra_params },
      ['mobile', 'type']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} email - email address
   * @param {string} verify_ticket - the ticket returned by verification
   * @return {Promise} send result
   */
  sendEmailCodeToNewManager = (params: {
    email: string;
    verify_ticket: string;
    extra_params?: object;
  }) => {
    const { email, verify_ticket, extra_params = {} } = params;
    const data = encryptParams(
      { email, verify_ticket, type: 101, ...extra_params },
      ['email', 'type']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} mobile - mobile number
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  verifyNewManagerMobile = (params: {
    mobile?: string;
    code: string;
    extra_params?: object;
  }) => {
    const { mobile, code, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, type: 101, ...extra_params }, [
      'mobile',
      'code',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CHECK_MOBILE_CODE,
        method: 'GET',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} email - email address
   * @param {number} code - the captcha
   * @return {Promise} verify result
   */
  verifyNewManagerEmail = (params: {
    email?: string;
    code: string;
    extra_params?: object;
  }) => {
    const { email, code, extra_params = {} } = params;
    const data = encryptParams({ email, code, type: 101, ...extra_params }, [
      'email',
      'code',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CHECK_EMAIL_CODE,
        method: 'GET',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} new_user_name - name of new manager
   * @param {string} new_admin_verify_ticket - verify ticket of new manager
   * @param {string} old_admin_verify_ticket - the ticket returned by verification
   * @param {number} old_admin_target_identity_id - the identity id of old manager after transfer
   * @param {string} new_admin_sec_user_id - the encrypted user id of new manager
   * @param {string} new_admin_sec_user_identity_id - the encrypted user identity id of new manager
   * @return {Promise} verify result
   */
  transferManager = (params: {
    new_user_name: string;
    new_admin_verify_ticket?: string;
    old_admin_verify_ticket: string;
    old_admin_target_identity_id?: number;
    new_admin_sec_user_id?: string;
    new_admin_sec_user_identity_id?: string;
    extra_params?: object;
  }) => {
    const { extra_params = {}, ...props } = params;
    return this.request({
      url: WEB_AFF_URL.TRANSFER_MANAGER,
      method: 'POST',
      data: {
        ...props,
        ...extra_params,
      },
    });
  };
}
